module.exports = __webpack_public_path__ + "static/media/IMG_4660.1a1e9a31.JPG";